const KBaseTab = {
  FILES: "files",
  WEBPAGES: "webpages",
  TABLES: "tables",
  INTEGRATIONS: "integrations",
};

export default KBaseTab;
